import React from 'react';

export const DovetailSearchResultIcon = (): React.JSX.Element => {
	return (
		// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			\{' '}
			<path
				d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
				fill="#292A2E"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.69929 18.4645C7.65493 18.4901 7.65493 18.5542 7.69929 18.5798L11.878 20.993C11.9191 21.0168 11.9445 21.0608 11.9445 21.1083V25.9335C11.9445 25.9847 12 26.0167 12.0444 25.9911L16.223 23.5779C16.2642 23.5541 16.2896 23.5102 16.2896 23.4626V18.599C16.2896 18.5514 16.2642 18.5075 16.223 18.4837L11.9445 16.0142L7.69929 18.4645Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.69929 8.43014C7.65493 8.45578 7.65493 8.51982 7.69929 8.54542L11.878 10.9587C11.9191 10.9825 11.9445 11.0264 11.9445 11.0739V16.0144L16.2896 13.5051V8.56466C16.2896 8.5171 16.2642 8.47314 16.223 8.44934L12.011 6.01822C11.9699 5.99442 11.9191 5.99442 11.878 6.01822L7.69929 8.43014Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.2896 13.5041L20.568 15.975C20.6092 15.9988 20.6346 16.0427 20.6346 16.0903V20.9155C20.6346 20.9667 20.6901 20.9987 20.7344 20.9731L24.9131 18.5599C24.9543 18.5361 24.9796 18.4921 24.9796 18.4446V13.581C24.9796 13.5334 24.9543 13.4895 24.9131 13.4657L20.7012 11.0345C20.66 11.0108 20.6092 11.0108 20.568 11.0345L16.2896 13.5041Z"
				fill="white"
			/>
		</svg>
	);
};
